import React, { useRef, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Dialog, DialogContent } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangeIcon } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const green = {
  50: "#74b44a",
  100: "#74b44a",
  200: "#74b44a",
  300: "#74b44a",
  400: "#74b44a",
  500: "#74b44a",
  600: "#74b44a",
  700: "#74b44a",
  800: "#74b44a",
  900: "#74b44a",
  A100: "#74b44a",
  A200: "#74b44a",
  A400: "#74b44a",
  A700: "#74b44a",
};

const defaultMaterialTheme = createTheme({
  palette: {
    primary: green,
  },
});

export default function DatePicker({
  value,
  setValue,
  label,
  iconStyle,
  iconPosition = "start",
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [tempValue, setTempValue] = useState(dayjs());
  const showLabel = Boolean(label);
  const anchorRef = useRef(null);

  return (
    <>
      <div
        ref={anchorRef}
        className={`float-label ${
          disabled ? "disable-time" : "cursor-pointer-all"
        } pointer-wrap`}
        onClick={() => {
          if (!disabled) {
            const initialValue = value ? dayjs(value) : dayjs();
            setTempValue(initialValue);
            setOpen(true);
          }
        }}
        style={{
          position: "relative",
        }}
      >
        {showLabel && (
          <label
            style={{ paddingLeft: value ? "20px" : "40px" }}
            className={value ? "Active input-field" : "input-field"}
          >
            {label}
          </label>
        )}

        {/* Left icon */}
        {iconPosition === "start" && (
          <DateRangeIcon
            style={{
              position: "absolute",
              top: showLabel
                ? `calc(50% - ${value ? "3px" : "7px"})`
                : "calc(50% - 2px)",
              left: "12px",
              transform: showLabel ? "none" : "translateY(-50%)",
              cursor: "pointer",
              color: "#74b44a",
              fontSize: "20px",
              ...iconStyle,
            }}
          />
        )}

        <input
          style={{
            paddingLeft: showLabel && "40px",
            paddingRight: iconPosition === "end" ? "40px" : "16px",
            paddingTop: showLabel ? "17px" : "0",
            pointerEvents: "none",
          }}
          className="form-control"
          value={value ? dayjs(value).format("MM/DD/YY") : ""}
          type="text"
          disabled={disabled}
          readOnly
        />

        {/* Right icon */}
        {iconPosition === "end" && (
          <DateRangeIcon
            style={{
              position: "absolute",
              top: showLabel ? `calc(50% - ${value ? "0px" : "7px"})` : "50%",
              right: "15px",
              transform: showLabel ? "none" : "translateY(-50%)",
              cursor: "pointer",
              color: "#74b44a",
              ...iconStyle,
            }}
          />
        )}
      </div>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xs"
        PaperProps={{
          style: {
            borderRadius: "16px",
          },
        }}
      >
        <DialogContent style={{ padding: 0 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ThemeProvider theme={defaultMaterialTheme}>
              <StaticDatePicker
                value={tempValue}
                onChange={(newValue) => {
                  setTempValue(newValue);
                }}
                disabled={disabled}
                slotProps={{
                  actionBar: {
                    actions: ["cancel", "accept"],
                    onAccept: () => {
                      if (tempValue && tempValue.isValid()) {
                        const formattedDate = tempValue.format("YYYY-MM-DD");
                        setValue(formattedDate);
                      }
                      setOpen(false);
                    },
                    onCancel: () => {
                      setOpen(false);
                    },
                  },
                }}
              />
            </ThemeProvider>
          </LocalizationProvider>
        </DialogContent>
      </Dialog>
    </>
  );
}
